import type { SceneContent } from '../../presentation/types';

/**
 * ClimateViewPoint is the rebrand of Sustain Insight (owner decision 2026-10-10). Identity follows
 * ClimateViewPoint-Brand-Guidelines.pdf. Every factual claim below is unchanged from the original
 * product content (docs/product-content/CLIMATEVIEWPOINT.md, formerly SUSTAIN-INSIGHT.md): the
 * rebrand is not evidence of new features. Headlines use sentence case (guideline p. 12).
 */
export const climateViewPoint: SceneContent = {
  id: 'climateviewpoint',
  shortLabel: 'CLIMATEVIEWPOINT',
  title: 'ClimateViewPoint — Less Noise, More Relevance',
  seconds: 50,
  brand: 'climateviewpoint',
  bridgeIn: (context) => (context.isEnabled('carbonmove')
    ? 'Another independent product deals with a different kind of overload.'
    : 'Moderta also builds independent products. One deals with a particular kind of overload.'),
  atmosphere: (step) =>
    step <= 1 ? { pattern: 'stream', density: 0.16 + step * 0.1, opacity: 0.04, cameraZ: 13.8 }
    : { pattern: step >= 3 ? 'inward' : 'ambient', density: 0.1, opacity: 0.03, cameraZ: 14.4 },
  script: {
    title: 'ClimateViewPoint — Less Noise, More Relevance',
    onScreen: ['The story changes every day.', "Your attention doesn't scale with it.", 'ClimateViewPoint', 'A focused sustainability briefing, built around relevance.', 'Sources → Ingest → Organise → Filter', 'For you · All news · Bookmarks', 'Preferences · Bookmarks · Engagement', 'Less noise. More relevance.'],
    visual: 'Topic lanes of editorial cards, each with a format label and unreadable headline rules, glide across the Understory field, then more arrive, faster. Everything slows; the ClimateViewPoint reverse logo resolves with a single Horizon-gradient rule beneath it. A calm editorial flow draws: many sources into ingest, organise and filter, with fewer items leaving each stage, out to For you, All news and Bookmarks. A loop from the reader carries preferences, bookmarks and engagement back into the filter.',
    narration: [
      'Sustainability moves quickly. New policies, energy and climate developments, research, finance and reporting news arrive from many sources every day.',
      'For anyone following it professionally, keeping up should not mean reading everything.',
      'ClimateViewPoint is a focused sustainability briefing, built around relevance.',
      'Behind it, the platform fetches sustainability news from external sources on a schedule, removes duplicates, and organises articles by topic and source. Readers get a personalised For You feed, a searchable All News index they can filter by category and source, and bookmarks to come back to.',
      'What a reader sets as preferences, saves and engages with feeds back into the For You feed. Less noise. More relevance.',
    ],
    presenterNotes: [
      'Topic lanes glide past. "The story changes every day."',
      'More, faster. "Your attention doesn\'t scale with it."',
      'Everything slows. Reveal ClimateViewPoint.',
      'The flow: ingest, organise, filter. Then the three places a reader goes.',
      'The loop closes. "Less noise. More relevance." Do not call it an AI recommender.',
    ],
  },
};
